module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAqElEQVQoka3SMQrCQBCF4X9DKtFWtgt2KtjYS2ovIYKFN7BV8AzewlvkJNu9XiR2Y7PCJjZJdJplmP0YHowry60xoPL4up7OsiHbAP4Dg1QFqRq6sVPePG0K7zdd0LOum7BLBWnhnPuGQToDY+BUeG+t2Qi4m1kTRnSJ7TRIx8L7V/LlBiwhydhCADtgFaQDIOAK7D9DN5uvzcwewKRP1szM6Ivgh8t5A01mNgWAvpiJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/17c.png
// module id = dJiF
// module chunks = 65